<app-search-with-details [(searchInProgress)]="searchInProgress" [(sortField)]="currentSortField" [fields]="fields" [sortColumns]="sortFields" [foundSet]="searchResults" (doSearch)="doSearch($event)" (doSort)="doSort($event)" (resultSelected)="resultSelected($event)">
    <ng-template #details>
        <app-instance [modelData]="selectedResult"></app-instance>
    </ng-template>
</app-search-with-details>